<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.abm.folders.modals.cancelSubFolder.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            <span>{{ $t('message.abm.folders.modals.deleteSubFolderConfig.label') }}</span>
          </p>
          <div v-for="item in stateFolder.subFolderParams.documentConfiguration.appliedConfig" :key="item.id" class="custom-color-text-appliedConfig bg-zt-dark-200 inline-block rounded py-2 pl-2 pr-3 mb-3 mr-3 items-center">
            <zt-icon :name="item.icon" />
            <span class="ml-2">{{item.name}}</span>
				  </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
          data-vs-button="closeDialog"
        >
          {{ $t('message.abm.folders.modals.deleteSubFolderConfig.buttonSecondary') }}
        </zt-button>
        <zt-button
          color="danger"
          class="w-25"
          @click="confirmLeave"
          data-vs-button="confirmLeave"
        >
          {{ $t('message.abm.folders.modals.deleteSubFolderConfig.buttonDeletePrimary') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'DeleteSubFolderConfigDialog',
  inject: [ 'activeModalDelete', 'setDocumentConfiguration','stateFolder', 'resetPreviewConfiguration', 'resetDocumentConfiguration' ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    isLeave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.activeModalDelete(false)
    },
    async confirmLeave() {
      await this.resetPreviewConfiguration()
      await this.resetDocumentConfiguration()
      this.activeModalDelete(false)
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
